import { render, staticRenderFns } from "./ConsentsMainLogo.vue?vue&type=template&id=231b8e70"
import script from "./ConsentsMainLogo.vue?vue&type=script&lang=js"
export * from "./ConsentsMainLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports